/**
 * A page declaring that it fills the viewport and scrolls inside itself.
 *
 * Most pages are documents: they are as long as their content and the browser
 * scrolls them. A few are instruments — panes side by side, each scrolling on
 * its own, with the chrome always where it was — and those need the page
 * itself not to scroll at all.
 *
 * That is a fact about the page, but only the shell can act on it, since the
 * shell owns the element the viewport height has to land on. So the page says
 * it and the shell does it, rather than the shell keeping a list of which
 * routes are which.
 *
 * Locking is released on unmount, so navigating away restores ordinary
 * document scrolling without the page it left having to remember.
 */import{createContext,useContext,useEffect}from"react";// Set by the shell. The default is a no-op so a page rendered outside the
// shell — in a test, say — neither breaks nor silently does nothing it
// claimed to do.
export const ViewportLockContext=/*#__PURE__*/createContext(()=>{});export default function useViewportLock(){const setLocked=useContext(ViewportLockContext);useEffect(()=>{setLocked(true);return()=>setLocked(false);},[setLocked]);}